// Типы действий среза option (глобальные справочники для селектов).
export const SET_NODES = 'option/SET_NODES';
export const SET_DEVICE_TYPES = 'option/SET_DEVICE_TYPES';
export const SET_DEVICE_STATUSES = 'option/SET_DEVICE_STATUSES';
export const SET_NODE_STATUSES = 'option/SET_NODE_STATUSES';
export const SET_PROXIES = 'option/SET_PROXIES';
export const SET_DEVICE_PROXY_STATUSES = 'option/SET_DEVICE_PROXY_STATUSES';
export const SET_DEVICE_HEALTH_STATUSES = 'option/SET_DEVICE_HEALTH_STATUSES';
export const SET_PROXY_GROUPS = 'option/SET_PROXY_GROUPS';
export const SET_NODE_IPS = 'option/SET_NODE_IPS';
export const SET_DEVICE_PROXY_MODES = 'option/SET_DEVICE_PROXY_MODES';
